module.exports = __webpack_public_path__ + "img/icon_page1_line4.315a772c.png";